import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';


const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <XyzTransition
      appear
      xyz='fade-100% small out-down appear-stagger duration-15 ease-in-out-back'
    >
      <footer className="footer bg-dark text-white py-2 mt-auto fixed-bottom">
        <Container className="text-center">
          <Row>
            <Col md={6}>
              {/* <small>Tous droits réservés © {new Date().getFullYear()}</small> */}
              <small className="text-white text-center small mt-4">
                © {currentYear} my-memento.fr — Tous droits réservés
              </small>
            </Col>

            <Col md={6} className="text-md-end">
              <Link to="/" className="memento text-white text-decoration-none mt-4 me-3">Memento</Link>
            </Col>
          </Row>
        </Container>
      </footer>
    </XyzTransition >
  );
};

export default Footer;